<template>
  <o-card :enable-back="true" :title="$t('medtastic.contact')" class="col-lg-12">
    <div class="pb-3">
      <p>
        {{ $t('medtastic.contact_text') }}
      </p>
      <p>
        <b>medtastic GmbH</b><br>
        Bürglistrasse 8<br>
        8002 Zürich<br>
        {{ $t('core.phone') }}: 044 552 25 45<br>
        {{ $t('core.email') }}: <a href="mailto:contact@medtastic.ch">contact@medtastic.ch</a>
      </p>
    </div>
  </o-card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  layout: 'user',
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  }
}
</script>
